import React, { useState } from 'react';
import { Fade } from "react-awesome-reveal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStickyNote } from '@fortawesome/free-solid-svg-icons';

function Notas() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bg-cover bg-center bg-no-repeat bg-fixed" style={{ backgroundImage: `url(${require('../../Imagenes/5.png')})`}}>
    <div className="p-8 text-center">
         <div className="flex flex-col items-center bg-verde3 rounded-lg ">
      <h2 className="font-Libre-Baskerville text-white text-3xl md:text-5xl mt-6 text-center">Notas</h2>
     
      <div className='flex justify-center items-center mb-10 mt-10'>
        <Fade cascade={true} duration={3000}>
          <FontAwesomeIcon icon={faStickyNote} size="5x" className="text-white" />
        </Fade>
      </div>
      
      <div className="text-1xl font-bold text-white mb-4 ml-7 mr-7 text-center">
        <p>Información adicional para tener en cuenta</p>
      </div>
      
      <Fade direction="left">
        <button
          className="font-bold text-lg text-white mb-10 bg-verde2 rounded-md px-6 py-2 transition-colors duration-300 ease-in-out hover:bg- focus:outline-none focus:ring-2 focus:ring- focus:ring-opacity-50"
          onClick={handleOpenModal}
        >
          + Info
        </button>
      </Fade>
   
      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-verde5 p-8 rounded-md max-w-sm w-full">
            <h3 className="text-xl text-verde1 font-bold mb-4">Nota Importante</h3>
            <p className="mb-6">
              ¡Por favor ser puntuales! 
            </p>
            
            <p className="mb-6">
            Solo la novia puede usar blanco o tonos similares, ¡el resto disfruten con sus colores favoritos!
            </p>
            <p className="mb-6">
              Descargar el GoogleDrive para que puedas subir tus fotos en la carpeta compartida. 
            </p>
            <p className="mb-6">
            El amor se celebra con alegría y respeto, gracias por acompañarnos.
            </p>
            <p className="mb-6">
              Olvidarse de todo, y ¡¡¡ a disfrutar !!! 
            </p>
            <button
              className="bg-verde2 text-white font-bold py-2 px-4 rounded hover:bg-verde3 transition-colors duration-300"
              onClick={handleCloseModal}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>  </div> </div>
  );
}

export default Notas;
